"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLogoffContext = exports.LogoffProvider = void 0;
var _react = _interopRequireWildcard(require("react"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const LogoffContext = /*#__PURE__*/(0, _react.createContext)({
  logoffEnabled: true,
  logoffMessage: null,
  setLogoffEnabled: () => {},
  setLogoffMessage: () => {}
});
const LogoffProvider = _ref => {
  let {
    children
  } = _ref;
  const [logoffEnabled, setLogoffEnabled] = (0, _react.useState)(true);
  const [logoffMessage, setLogoffMessage] = (0, _react.useState)(null);
  return /*#__PURE__*/_react.default.createElement(LogoffContext.Provider, {
    value: {
      logoffEnabled,
      setLogoffEnabled,
      logoffMessage,
      setLogoffMessage
    }
  }, children);
};
exports.LogoffProvider = LogoffProvider;
const useLogoffContext = () => (0, _react.useContext)(LogoffContext);
exports.useLogoffContext = useLogoffContext;